import React from 'react';
import './late-label.scss';

const LateLabel = () => <div styleName="late-label-container">Late</div>;

export default LateLabel;
